import Application from "../../Application";
import { IUserService } from "../../user/service/UserService";
import { IAuthenticationService } from "../service/AuthenticationService";
export default class ChangePasswordInteractor {
  private application: Application;
  private authenticationService: IAuthenticationService;
  private userService: IUserService;

  constructor({ application, authenticationService, userService }) {
    this.application = application;
    this.authenticationService = authenticationService;
    this.userService = userService;
  }

  async execute(newPassword: string, oldPassword: string, username?: string) {
    let userProfile;
    if (!username) {
      userProfile = await this.userService.getUserProfile();
    }
    return this.authenticationService.changePassword(
      newPassword,
      oldPassword,
      username || userProfile.username
    );
  }
}
